import { Primary } from '@cinch-labs/design-system'
import { Field, Form } from 'react-final-form'

import styles from './search-form.module.css'
import TextFieldWrapper from './text-field-search'

export const SearchForm: React.FC<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (values: any) => Promise<void> | undefined
  initialValues?: Record<string, unknown>
  isPending: boolean
}> = ({ onSubmit, initialValues = {}, isPending }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    render={({ handleSubmit, pristine }) => (
      <form
        name="jargon-search"
        onSubmit={handleSubmit}
        className={styles.form}
      >
        <Field
          id="searchInput"
          name="search"
          type="search"
          component={TextFieldWrapper}
          label="I want to understand"
          autoComplete="off"
          placeholder="E.g. Car Insurance"
          fullWidth={true}
        />

        <Primary
          classNames={{ button: styles.button }}
          type="submit"
          disabled={pristine || isPending}
          isLoading={isPending}
        >
          Search
        </Primary>
      </form>
    )}
  />
)
